import React from 'react';
import PropTypes from 'prop-types';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import { isEmpty, isIn, isNumeric } from 'validator';
import shortid from 'shortid';
import moment from 'moment';
import swal from 'sweetalert2';
import {
    changeStep, validateInputArray, getPicklist, updateRegistrationData, resetRegistration, updateAttachment,
    saveAsDraft,
} from '../actions';
import OtherHouseholdMember01 from './OtherHouseholdMember01';
import OtherHouseHoldMember02 from './OtherHouseHoldMember02';
import { validateNRIC } from '../../../../utils/common';

class Tab4 extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            form: [],
            attachment: props.attachment || [],
            errorMessage: [],
        };
        this.validateInputArray = validateInputArray.bind(this);
        this.onAddMember = this.onAddMember.bind(this);
        this.removeOtherMember = this.removeOtherMember.bind(this);
        this.onInputChanged = this.onInputChanged.bind(this);
        this.validationList = this.validationList.bind(this);
        this.onFileUploaded = this.onFileUploaded.bind(this);
        this.onRemoveFile = this.onRemoveFile.bind(this);
    }

    componentWillMount() {
        this.props.changeStep(3);
        const { tab2, tab3, tab4 } = this.props;
        if (tab2 === null) window.location = '/portal/registration-v2/';
        if (tab3 === null) window.location = '/portal/registration-v2/step-2';
        // Changed with redux state
        let otherMember = [];
        if (tab4 === null || tab4.length === 0) {
            otherMember.push({
                mainApplicant: true,
                Full_Name__c: tab2.Full_Name__c,
                ID_Type__c: tab2.ID_Type__c,
                ID_Number__c: tab2.ID_Number__c,
                Date_of_Birth__c: moment(tab2.Date_of_Birth__c),
                Gender__c: tab2.Gender__c,
                Race__c: tab2.Race__c,
                Other_Race__c: tab2.Other_Race__c,
                Nationality__c: tab2.Nationality__c,
                Other_Nationality__c: tab2.Other_Nationality__c,
                Marital_Status__c: tab2.Marital_Status__c,
                Other_Marital_Status__c: tab2.Other_Marital_Status__c,
            });
        } else {
            otherMember = tab4.map((ob, index) => ({
                ...ob,
                Date_of_Birth__c: moment(ob.Date_of_Birth__c),
                mainApplicant: tab4.Main_Applicant__c || index === 0,
            }));
            otherMember[0].Full_Name__c = tab2.Full_Name__c;
            otherMember[0].ID_Type__c = tab2.ID_Type__c;
            otherMember[0].ID_Number__c = tab2.ID_Number__c;
            otherMember[0].Date_of_Birth__c = moment(tab2.Date_of_Birth__c);
            otherMember[0].Gender__c = tab2.Gender__c;
            otherMember[0].Race__c = tab2.Race__c;
            otherMember[0].Other_Race__c = tab2.Other_Race__c;
            otherMember[0].Nationality__c = tab2.Nationality__c;
            otherMember[0].Other_Nationality__c = tab2.Other_Nationality__c;
        }
        this.setState({ form: otherMember });
    }

    onAddMember() {
        const { form: otherMember } = this.state;
        otherMember[otherMember.length] = { shortid: shortid(), mainApplicant: false };
        this.setState({ otherMember });
    }

    async onFileUploaded(e) {
        e.preventDefault();
        const { attachment } = this.state;
        const { name } = e.target;
        const names = name.split('.');
        const prefixFile = { NricFin: 'Nric_Fin_', CPMF: 'cpmf_statement_', Payslip: 'payslip_' };
        if (e.target.files[0] !== undefined) {
            const file = e.target.files[0];
            const originalFileName = file.name.replace(/ |-/g, '_');
            const fileName = prefixFile[names[0]] + shortid() + (originalFileName.length > 20 ? originalFileName.substr(0, 20) : originalFileName);
            // const encodedFile = await getBase64(file);
            const attachmentFile = {
                Name: fileName,
                // Body: encodedFile.split(',')[1],
                fileData: window.URL.createObjectURL(file),
                parentId: '',
                ContentType: file.type,
            };
            attachment[names[1]] = attachment[names[1]] || {};
            attachment[names[1]] = {
                ...attachment[names[1]],
                [names[0]]: attachmentFile,
            };
            this.setState({ attachment });
        }
    }

    onRemoveFile(fieldName, index) {
        const { attachment } = this.state;
        delete attachment[index][fieldName];
        this.setState({ attachment });
    }

    onInputChanged(e, fieldName = null, index = 0) {
        const { form } = this.state;

        if (fieldName) {
            if (moment.isMoment(e)) {
                form[index][fieldName] = e;
            } else {
                form[index][fieldName] = e;
            }
            this.validateInputArray(this.validationList(index), false, index);
        } else {
            const { name, value } = e.target;
            const names = name.split('.');
            form[names[1]] = form[names[1]] || {};
            form[names[1]][names[0]] = value;
            this.validateInputArray(this.validationList(names[1]), false, parseInt(names[1], 10));
        }
        this.setState({ form });
    }

    validationList(index) {
        const { form } = this.state;
        const { objectInfo } = this.props;
        return {
            Full_Name__c: { validate: val => !isEmpty(val || '') },
            ID_Number__c: {
                message: 'Invalid FIN or NRIC',
                validate: val => form[index].ID_Type__c === 'Others' || validateNRIC(val || ''),
            },
            ID_Type__c: {
                validate: (val) => {
                    const listValue = getPicklist('ID_Type__c', objectInfo.Person__c, 'object')
                        .map(o => o.value);
                    return listValue.indexOf(val) > -1;
                },
            },
            Date_of_Birth__c: { validate: val => !isEmpty(val ? val.toString() : '') },
            // Gender__c: { validate: val => isIn(val || '', ['Male', 'Female']) },
            // Race__c: {
            //     validate: val => isIn(val || '', getPicklist('Race__c', objectInfo.Person__c, 'object')
            //         .map(o => o.value)),
            // },
            // Other_Race__c: { validate: val => (form[index].Race__c === 'Others' ? !isEmpty(val || '') : true) },
            Nationality__c: { validate: val => !isEmpty(val || '') },
            Other_Nationality__c: { validate: val => (form[index].Nationality__c === 'Others' ? !isEmpty(val || '') : true) },
            Relationship_to_Beneficiary__c: {
                validate: val => isIn(val || '', getPicklist('Relationship_to_Beneficiary__c', objectInfo.Person__c, 'object')
                    .map(o => o.value),
                ),
            },
            Other_Relationship__c: { validate: val => (form[index].Relationship_to_Beneficiary__c === 'Others' ? !isEmpty(val || '') : true) },
            Monthly_Gross_Income__c: { validate: val => isNumeric(val || ''), message: 'must be a number' },
            // Employment_Status__c: {
            //     validate: val => !isEmpty(val || ''),
            // },
            // Other_Source_of_Income__c: {
            //     validate: val => !isEmpty(val || '') || !form[index].mainApplicant,
            // },
            Other_Source_of_Income_Amount__c: {
                validate: (val) => {
                    if (!form[index].mainApplicant) return true;
                    if (form[index].Other_Source_of_Income__c === 'None') return true;
                    return isNumeric(val || '');
                },
            },
            // Occupation__c: { validate: val => form[index].Employment_Status__c === 'Unemployed' || !isEmpty(val || '') },
            // Company__c: { validate: val => form[index].Employment_Status__c === 'Unemployed' || !isEmpty(val || '') },
        };
    }

    removeOtherMember(index) {
        const { form: otherMember, errorMessage } = this.state;
        swal.fire({
            title: 'Are you sure?',
            text: "You won't be able to revert this!",
            type: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Yes, delete it!',
        }).then((result) => {
            if (result.value) {
                otherMember.splice(index, 1);
                errorMessage.splice(index, 1);
                this.setState({ otherMember, errorMessage });
                swal.fire(
                    'Deleted!',
                    'Beneficiary has been deleted.',
                    'success',
                );
            }
        });
    }

    render() {
        const { form: otherMember, errorMessage, attachment } = this.state;
        const { objectInfo } = this.props;
        return (
            <div className="row" id="">
                {otherMember.map((member, index) => (
                    <div className="form">
                        <div className="row">
                            <h4 className="pull-left">{member.mainApplicant ? 'Main Applicant' : `Member - ${index}`}</h4>
                            {member.mainApplicant ? null
                                : (
                                    <div className="pull-right">
                                        <a href={null} className="btn btn-md btn-fill btn-danger" type="button" onClick={() => this.removeOtherMember(index)}>
                                            <i className="fa fa-trash" />
                                            Delete
                                        </a>
                                    </div>
                                )
                            }
                            <div className="clearfix" />
                        </div>
                        <hr />
                        <OtherHouseholdMember01
                            form={member}
                            mainApplicant={member.mainApplicant}
                            objectInfo={objectInfo}
                            index={index}
                            errorMessage={errorMessage[index] || {}}
                            onInputChanged={this.onInputChanged}
                            shortid={shortid()}
                        />
                        <OtherHouseHoldMember02
                            form={member}
                            mainApplicant={member.mainApplicant}
                            objectInfo={objectInfo}
                            index={index}
                            errorMessage={errorMessage[index] || {}}
                            onInputChanged={this.onInputChanged}
                            onFileUploaded={this.onFileUploaded}
                            onRemoveFile={this.onRemoveFile}
                            attachment={attachment[index] || {}}
                            shortid={shortid()}
                        />
                    </div>
                ))}
                <div className="row">
                    <div className="text-center col-lg-12">
                        <button
                            className="btn btn-md btn-primary"
                            onClick={this.onAddMember}
                        >
                            <i className="fa fa-plus" />
                            Add Household Member
                        </button>
                    </div>
                </div>
                <div className="text-center">
                    <div className="btn-group">
                        <Link
                            to="/step-2"
                            key="prev-tab2"
                            className="btn btn-md btn-warning btn-fill "
                            onClick={() => {
                                window.scrollTo({ top: 0 });
                            }}
                        >
                            <i className="fa fa-arrow-left" />
                            Previous
                        </Link>
                        <a href={null} type="reset" className="btn btn-info btn-fill" onClick={this.props.resetRegistration}>
                            <i className="fa fa-refresh" /> Clear Form
                        </a>
                        <a
                            href={null}
                            className="btn btn-md btn-inverse btn-fill "
                            onClick={(e) => {
                                document.querySelector('.main-panel').scrollTop = 300;
                                this.validateInputArray(this.validationList, true);
                                const isPassed = errorMessage.map(o => Object.keys(o).length === 0);
                                if (isPassed.indexOf(false) > -1) {
                                    e.preventDefault();
                                    swal.fire({
                                        title: 'Incomplete form',
                                        text: 'Please validate all data before saving.',
                                        type: 'warning',
                                    });
                                } else {
                                    const cleanOtherMember = otherMember.map((o) => {
                                        delete o.shortid;
                                        o.Main_Applicant__c = o.mainApplicant;
                                        delete o.mainApplicant;
                                        return o;
                                    });
                                    this.props.updateAttachment('4', attachment);
                                    this.props.updateRegistrationData('4', cleanOtherMember);
                                    this.props.saveAsDraft();
                                }
                            }}
                        >
                            <i className="fa fa-save" />
                            Save as Draft
                        </a>
                        <Link
                            to="/step-4"
                            key="next-tab2"
                            className="btn btn-md  btn-primary btn-fill"
                            onClick={(e) => {
                                // e.preventDefault();
                                document.querySelector('.main-panel').scrollTop = 300;
                                this.validateInputArray(this.validationList, true);
                                const isPassed = errorMessage.map(o => Object.keys(o).length === 0);
                                if (isPassed.indexOf(false) > -1) e.preventDefault();
                                else {
                                    const cleanOtherMember = otherMember.map((o) => {
                                        delete o.shortid;
                                        o.Main_Applicant__c = o.mainApplicant;
                                        delete o.mainApplicant;
                                        return o;
                                    });
                                    this.props.updateAttachment('4', attachment);
                                    this.props.updateRegistrationData('4', cleanOtherMember);
                                }
                            }}
                        >
                            Next
                            <i className="fa fa-arrow-right" />
                        </Link>
                    </div>
                </div>
            </div>
        );
    }
}

Tab4.propTypes = {
    changeStep: PropTypes.func.isRequired,
    objectInfo: PropTypes.object.isRequired,
    updateRegistrationData: PropTypes.func.isRequired,
    resetRegistration: PropTypes.func.isRequired,
    tab2: PropTypes.object.isRequired,
    tab3: PropTypes.object.isRequired,
    tab4: PropTypes.object.isRequired,
    updateAttachment: PropTypes.func.isRequired,
    attachment: PropTypes.array.isRequired,
    saveAsDraft: PropTypes.func.isRequired,
};

const mapDispatchToProps = dispatch => (
    bindActionCreators({
        changeStep,
        updateRegistrationData,
        resetRegistration,
        updateAttachment,
        saveAsDraft,
    }, dispatch)
);

const mapStateToProps = state => ({
    user: state.user,
    currentStep: state.registration.currentStep,
    objectInfo: state.objectInfo,
    tab2: state.registration.tab2,
    tab3: state.registration.tab3,
    tab4: state.registration.tab4,
    attachment: state.registration.attachment.tab4,
});


export default connect(mapStateToProps, mapDispatchToProps)(Tab4);



//////////////////
// WEBPACK FOOTER
// ./src/components/Portal/Registration/Tab4/index.js
// module id = 1016
// module chunks = 0